{% block sw_cms_block_category_listing %}
    <div class="sw-cms-block-category-listing">
        <slot name="content">
            {% block sw_cms_block_category_listing_slot_content %}{% endblock %}
        </slot>
    </div>
{% endblock %}